import { createBreakpoints } from '@chakra-ui/theme-tools'

export const BREAKPOINTS = createBreakpoints({
  sm: '450px',
  md: '768px',
  lg: '1170px',
  xl: '1440px',
  '2xl': '1680px',
})
